import { render, staticRenderFns } from "./TrashImpuestoHistorical.vue?vue&type=template&id=302cc74a&scoped=true"
import script from "./TrashImpuestoHistorical.vue?vue&type=script&lang=js"
export * from "./TrashImpuestoHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302cc74a",
  null
  
)

export default component.exports